export const gameSequenceKeys = {
	gameSequenceInfo: (matchId: string) => ['GAME_SEQUENCE_INFO', matchId] as const
};
